import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
    Progress,
} from "reactstrap"
import * as Yup from "yup"
import Flatpickr from "react-flatpickr";
import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TaskTable from "./TaskTable"
import Select from "react-select";
import LeadCreateModal from "components/Common/LeadCreateModal"
import DeleteModel from "common/deleteModel/deleteModel"
import ErrorModel from "common/errorModel/errorModel"
import CreateAppointmentModel from "pages/Appointment/CreateAppointmentModel"
import CreateParcelModel from "pages/Parcel/CreateParcelModel"
import FollowupDetails from "pages/Lead/FollowupDetails"
import TaskArchiveDetails from "./TaskArchiveDetails"
import CreateMakingModel from "pages/Making/CreateMakingModel"
import { dateFormat, formatDateToISO } from "pages/Common"
import { exportDataExcel } from "components/Common/ExportData"
import CreateCustomerAttendModel from "pages/CustomerAttend/CreateCustomerAttendModel"
import { GetObjByTaskStatus } from "_mock/Static_data"
import { routes } from "routes/path"

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let model1 = false
function TaskList() {
    document.title = `Tasks | Raja Rani Couture`
    let { pathname } = useLocation()
    const navigate = useNavigate()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    let { state } = useLocation()
    // useStates
    const [modal, setModal] = useState(false)
    const [modalStatusChange, setModalStatusChane] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [selectedUser, setSelectedUser] = useState({
        label: "Select",
        value: 0,
    })
    const [selectedUserIds, setSelectedUserIds] = useState([])
    const [selectedTitle, setSelectedTitle] = useState({})
    const [selectedTitlesIds, setSelectedTitlesIds] = useState([])

    const [isEdit, setIsEdit] = useState(false)
    const [userControls, setUserControls] = useState([])
    const [targetTaskTypeValue, setTargetTaskTypeValue] = useState(1)
    const [taskType, setTaskType] = useState([
        {
            Key: 1,
            Value: "Daily"
        },
        {
            Key: 2,
            Value: "Onece"
        },
        {
            Key: 3,
            Value: "On day"
        },
    ])
    const [leadTypeValue, setLeadTypeValue] = useState(0)
    const [titleTypeValue, setTitleTypeValue] = useState(0)
    const [leadType, setLeadType] = useState([])
    const [titles, setTitles] = useState([])
    const [taskTtile, setTaskTitle] = useState('')
    const [editData, setEditData] = useState()
    const [createTaskTtileModal, setCreateTaskTtileModal] = useState(false)
    const [taskId, setTaskId] = useState(0)
    const [status, setStatus] = useState(0)
    const [numberTarget, setNumberTarget] = useState(0)
    const [numberPercentage, setNumberPercentage] = useState(0)
    const [amountTarget, setAmountTarget] = useState(0)
    const [amountPercentage, setAmountPercentage] = useState(0)
    const [statusData, setStatusData] = useState()
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [inputNumberVal, setInputNumberVal] = useState(0);
    const [totalNumberAchieve, setTotalNumberAchieve] = useState(0);

    const [inputAmountVal, setInputAmountVal] = useState(0);
    const [totalAmountAchieve, setTotalAmountAchieve] = useState(0);
    const [titleerror, setTitleError] = useState(false)
    const [titleerrorMessage, setTitleErrorMessage] = useState('')
    const [leadTypeError, setLeadTypeError] = useState(false)
    const [usererror, setUserError] = useState(false)
    const [numberTargetError, setNumberTargetError] = useState(false)
    const [statusFilter, setStatusFilter] = useState(state?.status ? state?.status : 0)
    const [TargetTaskDate, setTargetTaskDate] = useState(dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    const [userFilter, setUserFilter] = useState(state?.userFilter ? state?.userFilter[0]?.value : 0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState(state?.dateFilter ? state?.dateFilter : [new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [numberTargetErrorValidation, setNumberTargetErrorValidation] = useState(false)
    const [amountTargetErrorValidation, setAmountTargetErrorValidation] = useState(false)
    const [taskIds, setTaskIds] = useState([])
    const [statusChange, setStatusChange] = useState(0)
    const [roleName, setRoleName] = useState(JSON.parse(localStorage.getItem("authUser")).RoleName)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
        getApi('Task/title/lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                    Value2: parseInt(item.Value2)
                }));
                setTitles(options)

            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
        getApi('Lead/type/lookup').then(({ data, status }) => {
            if (status === 200) {
                setLeadType(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const taskListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Task/list", {
            Status: parseInt(statusFilter),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: state?.searchText ? state?.searchText.trim() : searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
            AssignBy: parseInt(userFilter),
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
        }).then(({ data, status }) => {
            navigate(routes.task, {
                state: null
            });
            if (status === 200) {
                setTableData(data.TaskList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            taskListApi()
        }
    }, [searchText, displayStart, rowsPerPage, statusFilter, userFilter, dateFilter, dateDisble])


    // Create task-title handler
    const handleTaskClick = () => {
        toggle()
        setTargetTaskTypeValue(1)
        setSelectedTitle({})
        setSelectedUser({
            label: "Select",
            value: 0,
        })
        setSelectedTitlesIds([])
        setSelectedUserIds([])
        setTargetTaskDate(new Date())
        validation.handleReset()
        validation.setFieldValue("NumberTarget", 0)
        validation.setFieldValue("AmountTarget", 0)
        validation.setFieldValue("Description", '')
    }

    const handleStatusChange = () => {
        if (taskIds.length > 0) {
            toggleStatusChange()
        } else {
            toast.error("Please select Task", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        }
    }

    // Colors Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Title: 0,
            AssignBy: 0,
            TaskType: 0,
            LeadType: 0,
            NumberTarget: isEdit ? editData.NumberTarget : 0,
            AmountTarget: isEdit ? editData.AmountTarget : 0,
            Description: isEdit ? editData.Description : '',
            DcFigure: 0
        },
        validationSchema: Yup.object({
            Description: Yup.string().required("The Description is required"),
        }),
        onSubmit: values => {
            if (isEdit ? parseInt(selectedTitle?.value) == 0 : selectedTitlesIds.length == 0) {
                setTitleError(true)
                setTitleErrorMessage("Title is Required")
                setUserError(false)
                setLeadTypeError(false)
                setNumberTargetError(false)
                return true
            } else if (isEdit ? parseInt(selectedUser.value) == 0 : selectedUserIds.length == 0) {
                setTitleError(false)
                setTitleErrorMessage('')
                setLeadTypeError(false)
                setNumberTargetError(false)
                setUserError(true)
                return true
            } else if (leadTypeValue == 0 && (isEdit ? (parseInt(titleTypeValue) == 2 || parseInt(titleTypeValue) == 7) : (selectedTitlesIds.map(item => item.Value2).includes(2) || selectedTitlesIds.map(item => item.Value2).includes(7)))) {
                setLeadTypeError(true)
                setTitleError(false)
                setTitleErrorMessage('')
                setUserError(false)
                setNumberTargetError(false)
                return true
            } else if (targetTaskTypeValue == 1 && (isEdit ? (parseInt(selectedTitle?.value) == 2 || parseInt(selectedTitle?.value) == 7) : (selectedTitlesIds.map(item => item.Value2).includes(2) || selectedTitlesIds.map(item => item.Value2).includes(7))) && values.NumberTarget == 0) {
                setNumberTargetError(true)
                setLeadTypeError(false)
                setTitleError(false)
                setTitleErrorMessage('')
                setUserError(false)
                return true
            }
            setformSumitLoading(true)
            if (values) {
                setLeadTypeError(false)
                setTitleError(false)
                setTitleErrorMessage('')
                setUserError(false)
                setNumberTargetError(false)
                if (isEdit) {
                    putApi("Task/update", {
                        Id: taskId,
                        TaskTitleId: parseInt(selectedTitle?.value),
                        Description: values.Description,
                        LeadType: (parseInt(titleTypeValue) == 2 || parseInt(titleTypeValue) == 7) ? parseInt(leadTypeValue) : 0,
                        TaskType: parseInt(targetTaskTypeValue),
                        AssignBy: selectedUser?.value,
                        NumberTarget: parseInt(values.NumberTarget),
                        AmountTarget: parseInt(values.AmountTarget),
                        TargetDate: targetTaskTypeValue == 2 ? formatDateToISO(TargetTaskDate) : null,
                        TaskDate: targetTaskTypeValue == 3 ? formatDateToISO(TargetTaskDate) : null,
                        DcFigure: parseInt(values.DcFigure) || 0,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            taskListApi()
                            validation.handleReset()
                        }
                    })
                } else {
                    postApi("Task/create", {
                        TaskTitleIds: selectedTitlesIds?.map(item => item.value).join(','),
                        Description: values.Description,
                        AssignByIds: selectedUserIds?.map(item => item.value).join(','),
                        TaskType: parseInt(targetTaskTypeValue),
                        LeadType: (selectedTitlesIds.map(item => item.Value2).includes(2) || selectedTitlesIds.map(item => item.Value2).includes(7)) ? parseInt(leadTypeValue) : 0,
                        NumberTarget: parseInt(values.NumberTarget),
                        AmountTarget: parseInt(values.AmountTarget),
                        TargetDate: targetTaskTypeValue == 2 ? formatDateToISO(TargetTaskDate) : null,
                        TaskDate: targetTaskTypeValue == 3 ? formatDateToISO(TargetTaskDate) : null,
                        DcFigure: parseInt(values.DcFigure) || 0,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            taskListApi()
                            validation.handleReset()
                        }
                    })
                }
            }
        },
    })

    useEffect(() => {
        if (validation.values.NumberTarget > 0) {
            setNumberTargetError(false)
        }
    }, [validation.values.NumberTarget])


    const changeStatusValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Status: 1,
            ArchivedNumberTarget: '',
            ArchivedAmountTarget: '',
            Remarks: '',
            DcFigure: '',
        },
        validationSchema: Yup.object().shape({
            Remarks: Yup.string().required("The remark is required"),
            DcFigure: titleTypeValue == 8 ? Yup.string().required("The DcFigure is required") : Yup.string(),
        }),
        onSubmit: values => {
            if (values.ArchivedNumberTarget > numberTarget || values.ArchivedAmountTarget > amountTarget) {
                setAmountTargetErrorValidation(false)
                setNumberTargetErrorValidation(false)
                return true
            } else if (((values.ArchivedNumberTarget === "" || values.ArchivedNumberTarget === undefined) && numberTarget > 0)) {
                setAmountTargetErrorValidation(false)
                setNumberTargetErrorValidation(true)
                return true
            } else if (((values.ArchivedAmountTarget === "" || values.ArchivedAmountTarget === undefined) && amountTarget > 0)) {
                setAmountTargetErrorValidation(true)
                setNumberTargetErrorValidation(false)
                return true
            }
            else {
                setAmountTargetErrorValidation(false)
                setNumberTargetErrorValidation(false)
                postApi("Task/change-status", {
                    TaskId: taskId,
                    Status: parseInt(status),
                    NumberAchieved: parseInt(values.ArchivedNumberTarget || 0) || 0,
                    AmountAchieved: parseInt(values.ArchivedAmountTarget || 0) || 0,
                    Remark: values.Remarks,
                    DcFigure: parseInt(values.DcFigure || 0) || 0
                }).then(({ data, status }) => {
                    if (status === 200) {
                        taskListApi()
                        changeStatustoggle()
                    } else {
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                    setIsLoading(false)
                    setScreenLoad(false)
                })
            }
        },
    })

    // popup box handler
    const toggle = () => {
        setModal(!modal)
        model1 = model1 == false ? true : false
        validation.handleReset()
        if (!model1) {
            setIsEdit(false)
        }
    }
    const toggleStatusChange = () => {
        setModalStatusChane(!modalStatusChange)
    }

    const changeStatustoggle = () => {
        setModal1(!modal1)
        changeStatusValidation.handleReset()
        changeStatusValidation.setFieldValue("ArchivedNumberTarget", '')
        changeStatusValidation.setFieldValue("ArchivedAmountTarget", '')
    }

    const handleChangeStatus = (data) => {
        setTitleTypeValue(data?.TitleType)
        setCreateTaskTtileModal(false)
        setTaskId(data?.Id)
        setStatus(data?.Status)
        setTargetTaskTypeValue(data?.TaskType)
        setStatusData(data)
        setStatus(data?.TaskType != 1 ? 2 : 3)
        setTaskTitle(data?.Title)
        const percentageNumber = Math.round((data?.NumberAchieved / (data?.NumberTarget)) * 100);
        setNumberPercentage(percentageNumber)
        const percentageAmount = Math.round((data?.AmountAchieved / (data?.AmountTarget)) * 100);
        setAmountPercentage(percentageAmount)
        setAmountTarget(data?.AmountTarget)
        setTotalNumberAchieve(data?.NumberAchieved)
        setTotalAmountAchieve(data?.AmountAchieved)
        setNumberTarget(data?.NumberTarget)
        changeStatustoggle()
    }

    const handleArchivedNumberTarget = (inputTarget) => {
        setNumberPercentage(0)
        setInputNumberVal(0);
        setTotalNumberAchieve(0);
        let inputValue = parseInt(inputTarget) || 0
        changeStatusValidation.setFieldValue("ArchivedNumberTarget", parseInt(inputValue))
        const newInputVal = Number(inputValue);
        const diff = newInputVal - inputNumberVal;
        const newTotal = totalNumberAchieve + diff;
        const percentage = Math.round((newTotal / numberTarget) * 100);
        setNumberPercentage(percentage)
        setInputNumberVal(newInputVal);
        setTotalNumberAchieve(newTotal);

    }

    const handleArchivedAmountTarget = (inputTarget) => {
        setAmountPercentage(0)
        setInputAmountVal(0);
        setTotalAmountAchieve(0);
        changeStatusValidation.setFieldValue("ArchivedAmountTarget", parseFloat(inputTarget || 0))
        const newInputVal = Number(inputTarget);
        const diff = newInputVal - inputAmountVal;
        const newTotal = totalAmountAchieve + diff;
        const percentage = Math.round((newTotal / amountTarget) * 100);
        setAmountPercentage(percentage)
        setInputAmountVal(newInputVal);
        setTotalAmountAchieve(newTotal);
    }

    const handleEditTask = (data) => {
        setIsEdit(true)
        setEditData(data)
        setTaskId(data?.Id)
        setTitleTypeValue(data?.TitleType)
        setSelectedTitle({
            label: data?.Title,
            value: data?.TaskTitleId,
        })
        setLeadTypeValue(data?.LeadTypeId)
        setSelectedUser({
            label: data?.AssignByName,
            value: data?.AssignBy,
        })
        setTargetTaskDate(
            data?.TaskType == 2 ?
                dateFormat(
                    data?.TargetDate?.split("T")[0],
                    "dd-MM-yyyy"
                ) :
                dateFormat(
                    data?.TaskDate?.split("T")[0],
                    "dd-MM-yyyy"
                )
        )
        setTargetTaskTypeValue(data?.TaskType)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this task permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Task/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Task deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Task",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }

    }
    const [viewArchivedModal, setViewArchivedModal] = useState(false)
    const ArchivedModel = id => {
        setViewArchivedModal(!viewArchivedModal)
        setTaskId(id)
    }

    const handleCheckboxChange = (Id, isChecked) => {
        setTaskIds((prev) => {
            if (isChecked) {
                if (!prev.includes(Id)) {
                    return [...prev, Id];
                }
                return prev;
            } else {
                return prev?.filter(item => item !== Id);
            }
        });
    };

    const handleMasterCheckboxChange = (isChecked) => {
        if (isChecked) {
            const newIds = tableData
                .filter(item => item.Id)
                .map(item => item.Id);
            setTaskIds(newIds)

        } else {
            setTaskIds([]);
        }
    };

    const hadleStatusChangeSave = () => {
        if (statusChange != 0) {
            setformSumitLoading(true)
            postApi("Task/multitask-change-status", {
                TaskIds: taskIds?.join(','),
                Status: parseInt(statusChange),
            }).then(({ data, status }) => {
                if (status === 200) {
                    setformSumitLoading(false)
                    taskListApi()
                    toggleStatusChange()
                    setTaskIds([])
                    setStatusChange(0)
                } else {
                    setformSumitLoading(false)
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })
        } else {
            toast.error("Please select status", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        }
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: () => (
                    <input
                        type="checkbox"
                        className="form-check-input"
                        defaultChecked={
                            tableData.length > 0 &&
                            tableData.every(item => taskIds.includes(item.Id))
                        }
                        onChange={(e) => handleMasterCheckboxChange(e.target.checked)}
                    />
                ),
                accessor: "Id",
                disableSorting: true,
                isDisabled: (roleName == "Employee"),
                width: "5%",
                Cell: ({ row }) => {
                    const { Id } = row.original;
                    return (
                        <input
                            type="checkbox"
                            className="form-check-input"
                            defaultChecked={taskIds.includes(Id)}
                            onChange={(e) => handleCheckboxChange(Id, e.target.checked)}
                        />
                    );
                }
            },
            {
                Header: "Title",
                accessor: "Title",
                Cell: ({ value, row }) => {
                    return <>
                        {row.original.TaskType != 1 ?
                            < a
                                className="text-primary"
                                onClick={() => ArchivedModel(row.original.Id)}
                            >
                                {value}
                            </a >
                            :
                            <div> {value}</div>
                        }
                    </>
                },
            },
            {
                Header: "Assign By",
                accessor: "AssignByName",
            },
            {
                Header: "Task Type",
                accessor: "TaskType",
                width: "10%",
                Cell: ({ row }) => {
                    return <>
                        <div
                            className="textWrap"
                            style={{
                                height: "8px",
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            {row.original.TaskType == 1 ? "Daily" : row.original.TaskType == 2 ? "Onece" : row.original.TaskType == 3 ? "On day" : ""}
                        </div>
                    </>
                },
            },
            {
                Header: "Number Progress",
                accessor: "NumberAchieved",
                width: "10%",
                Cell: ({ row }) => {
                    const numberAchieved = parseInt(row?.original?.NumberAchieved) || 0;
                    const numberTarget = parseInt(row?.original?.NumberTarget) || 0;
                    const percentage = numberTarget == 0
                        ? 0
                        : Math.round(((numberAchieved) / numberTarget) * 100);
                    return (
                        <>
                            {numberTarget == 0 ?

                                <div style={{ display: "flex", justifyContent: "center", alignContent: "center", textAlign: "center" }}>No Target</div>
                                :
                                <div>
                                    <Progress
                                        color="primary"
                                        value={percentage || 0}
                                        style={{
                                            width: "235px",
                                            height: "15px",
                                            backgroundColor: "#e7e9ec",
                                        }}
                                    >
                                        {`${percentage == 0 ? "No Target" : percentage}%`}
                                    </Progress>
                                    <div style={{ display: "flex", justifyContent: "space-between", color: "black", fontSize: "10px" }}>
                                        <div> {`Achieved: ${numberAchieved}`} </div>
                                        <div>{`Target: ${numberTarget}`}</div>
                                    </div>
                                </div>
                            }
                        </>
                    );
                },
            },
            {
                Header: "Amount Progress",
                accessor: "AmountProgress", // optional, for internal use
                width: "14%",
                Cell: ({ row }) => {
                    const amountAchieved = row?.original?.AmountAchieved || 0;
                    const amountTarget = row?.original?.AmountTarget || 0;

                    const percentage = amountTarget === 0
                        ? 0
                        : Math.round((amountAchieved / amountTarget) * 100);

                    return (
                        <>
                            {amountTarget == 0 ?

                                <div style={{ display: "flex", justifyContent: "center", alignContent: "center", textAlign: "center" }}>No Target</div>
                                :
                                <div>
                                    <Progress
                                        color="success"
                                        value={percentage || 0}
                                        style={{
                                            width: "235px",
                                            height: "15px",
                                            backgroundColor: "#e7e9ec",
                                            color: "black"
                                        }}
                                    >
                                        {`${percentage}%`}
                                    </Progress>
                                    <div style={{ display: "flex", justifyContent: "space-between", color: "black", fontSize: "10px" }}>
                                        <div>{`Achieved: ₹ ${new Intl.NumberFormat('en-IN', {
                                            currency: 'INR',
                                            minimumFractionDigits: 2,
                                        }).format(amountAchieved || 0)}`}</div>
                                        <div>{`Target: ₹ ${new Intl.NumberFormat('en-IN', {
                                            currency: 'INR',
                                            minimumFractionDigits: 2,
                                        }).format(amountTarget || 0)}`}</div>
                                    </div>
                                </div>
                            }
                        </>
                    );
                },
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Status
                    </div>
                ),
                width: "10%",
                // width: 100,
                accessor: "Status",
                Cell: ({ row }) => {
                    return <>
                        <div
                            className="textWrap"
                            style={{
                                height: "8px",
                                textAlign: "center",
                                justifyContent: "center",
                            }}
                        >
                            {GetObjByTaskStatus(row.original.Status)[0].Key}
                        </div>
                    </>
                },
            },
            {
                Header: "Lead Type",
                accessor: "LeadTypeName",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original?.LeadTypeName ? row.original?.LeadTypeName : "N/A"}
                    </p>
                ),
            },
            // {
            //     Header: "Dc Figure",
            //     accessor: "DcFigure",
            //     width: "9%",
            //     Cell: ({ row }) => (
            //         <p className=" mb-0 text-center">
            //             {row.original?.DcFigure ? row.original?.DcFigure : 0}
            //         </p>
            //     ),
            // },
            {
                Header: "Target / Task Date",
                accessor: "TargetDate",
                width: "10%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {(row.original?.TargetDate != null && row.original.TaskType == 2) ? dateFormat(row.original?.TargetDate, "dd-MM-yyyy") : (row.original.TaskDate != null && row.original.TaskType == 3) ? dateFormat(row.original?.TaskDate, "dd-MM-yyyy") : "N/A"}
                    </p>
                ),
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "15%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <>
                            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                                <li className="mytooltip">
                                    {row.original.Status == 3 || row.original.Status == 4 ?
                                        <Button
                                            task-title="secondary"
                                            className="btn btn-primary btn-sm "
                                            color="secondary"
                                            style={{ cursor: "not-allowed" }}
                                        >
                                            Operation
                                        </Button>
                                        : <Button
                                            color="primary"
                                            task-title="primary"
                                            className="btn btn-primary btn-sm "
                                            onClick={() => handleChangeStatus(row.original)}
                                        >
                                            Operation
                                        </Button>
                                    }
                                </li>
                                {JSON.parse(localStorage.getItem("authUser")).RoleName == "Master" &&
                                    <>
                                        {row.original.Status == 3 || row.original.Status == 4
                                            ?
                                            <li className="mytooltip">
                                                <i
                                                    className={`fs-6 fas fa-edit btn-edit`}
                                                    style={{ cursor: "not-allowed", color: "#808080b3" }}
                                                ></i>
                                                <span className="mytext">Edit</span>
                                            </li>
                                            :
                                            <li className="mytooltip">
                                                <i
                                                    className=" fs-6 fas fa-edit btn-edit"
                                                    id={`edittooltip${row.original.Id}`}
                                                    onClick={() => handleEditTask(row.original)}
                                                ></i>
                                                <span className="mytext">Edit</span>
                                            </li>
                                        }

                                        <li className="mytooltip">
                                            <i
                                                className="fs-6 fas fa-trash-alt btn-delete"
                                                id={`deletetooltip${row.original.Id}`}
                                                onClick={() => handleDelete(row.original.Id)}
                                            ></i>
                                            <span className="mytext">Delete</span>
                                        </li>
                                    </>
                                }
                            </ul>
                        </>
                    )
                },
            },
        ],
        [tableData, taskIds]
    )

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const taskTitleToggle = () => {
        setCreateTaskTtileModal(!createTaskTtileModal)
    }

    const handleCreateTaskTitle = (taskTtile) => {
        taskTitleToggle()
    }

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Title", "Assign By", "Task Type", "Number Achieved", "Number Target", "Amount Achieved", "Amount Target", "Status", "Target Date", "Created By", "Created On"];
            const mainTitle = "Tasks";
            const widthObj = [{
                Key: "A",
                Value: 35,
            },
            {
                Key: "B",
                Value: 20,
            },
            {
                Key: "C",
                Value: 12,
            },
            {
                Key: "D",
                Value: 18,
            },
            {
                Key: "E",
                Value: 18,
            },
            {
                Key: "F",
                Value: 18,
            },
            {
                Key: "G",
                Value: 18,
            },
            {
                Key: "H",
                Value: 12,
            },
            {
                Key: "I",
                Value: 17,
            },
            {
                Key: "J",
                Value: 17,
            },
            {
                Key: "K",
                Value: 17,
            },
            ]
            const extention = "Tasks.xlsx"
            let excelSheetData = []

            postApi("Task/list", {
                Status: parseInt(statusFilter),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
                AssignBy: parseInt(userFilter),
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.TaskList?.length; index++) {
                        let dataObj = {
                            Title: data?.TaskList[index].Title,
                            AssignByName: data?.TaskList[index].AssignByName,
                            TaskType: data?.TaskList[index].TaskType == 1 ? "Daily" : data?.TaskList[index].TaskType == 2 ? "Onece" : data?.TaskList[index].TaskType == 3 ? "On day" : "",
                            NumberAchieved: data?.TaskList[index].NumberAchieved,
                            NumberTarget: data?.TaskList[index].NumberTarget,
                            AmountAchieved: Math.round(data?.TaskList[index].AmountAchieved).toFixed(2),
                            AmountTarget: Math.round(data?.TaskList[index].AmountTarget).toFixed(2),
                            // Status: data?.TaskList[index].Status == 1 ? "Assigned" : data?.TaskList[index].Status == 2 ? "In-Progress" : "Done",
                            Status: GetObjByTaskStatus(data?.TaskList[index].Status)[0].Key,
                            TargetDate: data?.TaskList[index].TargetDate == null
                                ? "N/A"
                                : dateFormat(data?.TaskList[index].TargetDate, "dd-MM-yyyy"),
                            CreatedOn: data?.TaskList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.TaskList[index].CreatedOn, "dd-MM-yyyy"),
                            CreatedByName: data?.TaskList[index].CreatedByName,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
            setIsLoading(false)
        }
    }

    const handleMultiTitlesSelected = (title) => {
        const leadTitleSelected = title.some(item => item.Value2 === 2 || item.Value2 === 7);
        const dcTitleSelected = title.some(item => item.Value2 === 8);
        const othertitleSelected = title.some(item => item.Value2 !== 2 && item.Value2 !== 7 && item.Value2 !== 8);
        if (leadTitleSelected && othertitleSelected) {
            setTitleError(true);
            setTitleErrorMessage('You cannot select lead and dc with other titles.')
            return;
        } else if (leadTitleSelected && dcTitleSelected) {
            setTitleError(true);
            setTitleErrorMessage('You cannot select lead and dc with other titles.')
            return;
        } else if (dcTitleSelected && othertitleSelected) {
            setTitleError(true);
            setTitleErrorMessage('You cannot select lead and dc with other titles.')
            return;
        }
        else {
            setSelectedTitlesIds(title)
            setTitleError(false)
            setTitleErrorMessage('')
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <TaskTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddTaskTitleList={true}
                            handleTaskClick={handleTaskClick}
                            handleStatusChange={handleStatusChange}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            roleName={roleName}
                        />

                        <Modal
                            isOpen={modal}
                            toggle={toggle}
                            centered={true}
                            size="xl"
                            style={{ width: !isMobile ? "900px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggle} tag="h5">
                                    {isEdit ? "Update Task" : "Create Task"}
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            validation.handleReset()
                                            return false
                                        }}
                                    >
                                        {isEdit ?
                                            <Row>
                                                <Col md={8}>
                                                    <FormGroup className="mb-2">
                                                        <Label
                                                            htmlFor="validationCustom03"
                                                            className="required"
                                                        >
                                                            Title
                                                        </Label>
                                                        <Select
                                                            unstyled
                                                            styles={titleerror ? colourStyles1 : colourStyles}
                                                            value={selectedTitle}
                                                            onChange={(e) => {
                                                                setSelectedTitle(e)
                                                                setTitleError(false)
                                                                setTitleErrorMessage('')
                                                            }}
                                                            options={titles}
                                                            className="select2-selection"
                                                        />
                                                        {titleerror ? (
                                                            <div className="name-required">
                                                                {titleerrorMessage}
                                                            </div>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup className="mb-2">
                                                        <Label
                                                            htmlFor="validationCustom03"
                                                            className="required"
                                                        >
                                                            Assign By
                                                        </Label>
                                                        <Select
                                                            unstyled
                                                            styles={usererror ? colourStyles1 : colourStyles}
                                                            value={selectedUser}
                                                            onChange={(e) => {
                                                                setSelectedUser(e)
                                                                setUserError(false)
                                                            }}
                                                            options={userControls}
                                                            className="select2-selection"
                                                        />
                                                        {usererror ? (
                                                            <div className="name-required">
                                                                {"Assign By is Required"}
                                                            </div>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            :
                                            <Row>
                                                <Col md={8}>
                                                    <FormGroup className="mb-2">
                                                        <Label htmlFor="validationCustom03" className="required">
                                                            Title
                                                        </Label>
                                                        <Select
                                                            unstyled
                                                            isMulti
                                                            styles={titleerror ? colourStyles1 : colourStyles}
                                                            value={selectedTitlesIds}
                                                            onChange={(e) => handleMultiTitlesSelected(e)}
                                                            options={titles}
                                                            className="select2-selection"
                                                        />
                                                        {titleerror ? (
                                                            <div className="name-required">
                                                                {titleerrorMessage}
                                                            </div>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup className="mb-2">
                                                        <Label
                                                            htmlFor="validationCustom03"
                                                            className="required"
                                                        >
                                                            Assign By
                                                        </Label>
                                                        <Select
                                                            unstyled
                                                            isMulti
                                                            styles={usererror ? colourStyles1 : colourStyles}
                                                            value={selectedUserIds}
                                                            onChange={(e) => {
                                                                setSelectedUserIds(e)
                                                                setUserError(false)
                                                            }}
                                                            options={userControls}
                                                            className="select2-selection"
                                                        />
                                                        {usererror ? (
                                                            <div className="name-required">
                                                                {"Assign By is Required"}
                                                            </div>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        }


                                        <Row>
                                            <Col md={2}>
                                                <FormGroup className="mb-2">
                                                    <Label
                                                        htmlFor="validationCustom03"
                                                        className="required"
                                                    >
                                                        Task Type
                                                    </Label>
                                                    <Input
                                                        type="select"
                                                        bsSize="sm"
                                                        id="validationCustom01"
                                                        className="form-control-sm"
                                                        name="taskType"
                                                        // onChange={validation.handleChange}
                                                        onChange={e => {
                                                            setTargetTaskTypeValue(e.target.value)
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={targetTaskTypeValue}
                                                    >
                                                        {/* <option value={0}>Select task type</option> */}
                                                        {taskType.map((item, index) => {
                                                            return (
                                                                <option key={index} value={item.Key}>
                                                                    {item.Value}
                                                                </option>
                                                            )
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03" className={`${targetTaskTypeValue == 1 && (isEdit ? (parseInt(selectedTitle?.value) == 2 || parseInt(selectedTitle?.value) == 7) : (selectedTitlesIds.map(item => item.Value2).includes(2) || selectedTitlesIds.map(item => item.Value2).includes(7))) ? "required" : ""}`}>
                                                        Number Target
                                                    </Label>
                                                    <Input
                                                        name="NumberTarget"
                                                        placeholder="0"
                                                        type="text"
                                                        className="form-control-sm"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        onKeyPress={handleKeyPress}
                                                        value={validation.values.NumberTarget}
                                                        invalid={numberTargetError}
                                                    />
                                                    {numberTargetError ? (
                                                        <FormFeedback type="invalid">
                                                            The Number Target is required
                                                        </FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03">
                                                        Amount Target
                                                    </Label>
                                                    <Input
                                                        name="AmountTarget"
                                                        placeholder="0"
                                                        type="text"
                                                        className="form-control-sm"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        onKeyPress={handleKeyPress}
                                                        value={validation.values.AmountTarget}
                                                        invalid={
                                                            validation.touched.AmountTarget && validation.errors.AmountTarget
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.AmountTarget && validation.errors.AmountTarget ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.AmountTarget}
                                                        </FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </Col>
                                            {(targetTaskTypeValue == 2 || targetTaskTypeValue == 3) &&
                                                <Col md={2}>
                                                    <FormGroup className="mb-2">
                                                        <div>
                                                            <Label htmlFor="FollowupValidation1Custom01" className={`${targetTaskTypeValue == 2 || targetTaskTypeValue == 3 ? "required" : ''}`}>
                                                                {targetTaskTypeValue == 2 ? "Target Date" : "Task Date"}
                                                            </Label>
                                                            <div className="d-flex date-after" >
                                                                <Flatpickr
                                                                    className="form-control d-block flatpicker-date"
                                                                    placeholder="dd-MM-yyyy"
                                                                    options={{
                                                                        // enableTime: true,
                                                                        dateFormat: "d-m-Y",
                                                                        disableMobile: true
                                                                    }}
                                                                    value={TargetTaskDate}
                                                                    onChange={(e) => { setTargetTaskDate(e) }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {((isEdit && titleTypeValue == 2) || (selectedTitlesIds.map(item => item.Value2).includes(2) || selectedTitlesIds.map(item => item.Value2).includes(7))) &&
                                                <Col md={2}>
                                                    <FormGroup className="mb-2">
                                                        <Label
                                                            htmlFor="validationCustom03"
                                                            className="required"
                                                        >
                                                            Lead Type
                                                        </Label>
                                                        <Input
                                                            type="select"
                                                            bsSize="sm"
                                                            id="validationCustom01"
                                                            className="form-control-sm"
                                                            name="leadType"
                                                            // onChange={validation.handleChange}
                                                            onChange={e => {
                                                                setLeadTypeValue(e.target.value)
                                                                setLeadTypeError(false)
                                                            }}
                                                            onBlur={validation.handleBlur}
                                                            value={leadTypeValue}
                                                        >
                                                            <option>Select lead type</option>
                                                            {leadType.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.Key}>
                                                                        {item.Value}
                                                                    </option>
                                                                )
                                                            })}
                                                        </Input>
                                                        {leadTypeError ? (
                                                            <div className="name-required">
                                                                {"Lead Type is Required"}
                                                            </div>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            }
                                            {/* {((isEdit && titleTypeValue == 8) || selectedTitlesIds.map(item => item.Value2).includes(8)) &&
                                                <Col md={2}>
                                                    <FormGroup className="mb-2">
                                                        <Label htmlFor="validationCustom03">
                                                            Dc Figure
                                                        </Label>
                                                        <Input
                                                            name="DcFigure"
                                                            placeholder="0"
                                                            type="text"
                                                            className="form-control-sm"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            onKeyPress={handleKeyPress}
                                                            value={validation.values.DcFigure}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            } */}
                                        </Row>
                                        <Row>
                                            <FormGroup className="mb-2">
                                                <Label htmlFor="validationCustom03" className="required">
                                                    Description
                                                </Label>
                                                <Input
                                                    name="Description"
                                                    placeholder="Enter decription here"
                                                    type="textarea"
                                                    className="form-control-sm"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.Description}
                                                    invalid={
                                                        validation.touched.Description && validation.errors.Description
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {validation.touched.Description && validation.errors.Description ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.Description}
                                                    </FormFeedback>
                                                ) : null}
                                            </FormGroup>
                                        </Row>

                                        <div className="text-end">
                                            {isEdit ? <Button
                                                task-title="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                color="secondary"
                                                onClick={() => toggle()}
                                            >
                                                Cancel
                                            </Button> :
                                                <Button
                                                    task-title="secondary"
                                                    className="btn btn-primary me-2 btn-sm "
                                                    type="reset"
                                                    color="secondary"
                                                >
                                                    Reset
                                                </Button>
                                            }
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    task-title="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={modal1}
                            toggle={changeStatustoggle}
                            centered={true}
                            size="xl"
                            style={{ width: !isMobile ? "900px" : "" }}
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={changeStatustoggle} tag="h5">
                                    Change Task Status
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            changeStatusValidation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            changeStatusValidation.handleReset()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col md={3}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03">
                                                        Status
                                                    </Label>
                                                    <Input
                                                        type="select"
                                                        bsSize="sm"
                                                        id="validationCustom01"
                                                        className="form-control-sm"
                                                        name="status"
                                                        onChange={e => {
                                                            setStatus(e.target.value)
                                                        }}
                                                        onBlur={changeStatusValidation.handleBlur}
                                                        value={status}
                                                    >
                                                        {statusData?.Status != 2 || targetTaskTypeValue != 2 &&
                                                            <option className="bg-light text-dark" value={1}>
                                                                Assigned
                                                            </option>}
                                                        {targetTaskTypeValue != 1 &&
                                                            <option className="bg-light text-dark" value={2}>
                                                                In-Progress
                                                            </option>}
                                                        <option className="bg-light text-dark" value={3}>
                                                            Done
                                                        </option>
                                                        <option className="bg-light text-dark" value={4}>
                                                            Discard
                                                        </option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03">
                                                        Archived Target (Number)
                                                    </Label>
                                                    <Input
                                                        name="ArchivedNumberTarget"
                                                        placeholder="target"
                                                        type="text"
                                                        className="form-control-sm"
                                                        onChange={(e) => {
                                                            let inputValue = e.target.value;
                                                            if (isNaN(inputValue)) {
                                                                inputValue = '';
                                                            }
                                                            // else if (inputValue < 0) {
                                                            //     inputValue = 0;
                                                            // }
                                                            handleArchivedNumberTarget(inputValue)
                                                        }}
                                                        onBlur={changeStatusValidation.handleBlur}
                                                        // onKeyPress={handleKeyPress}
                                                        value={changeStatusValidation.values.ArchivedNumberTarget}
                                                        // invalid={(totalNumberAchieve) > numberTarget}
                                                        invalid={(totalNumberAchieve > numberTarget ||
                                                            (numberTargetErrorValidation)
                                                        )}
                                                    />
                                                    {/* {(totalNumberAchieve) > numberTarget ? (
                                                        <FormFeedback type="invalid">
                                                            The archived number target is not match
                                                        </FormFeedback>
                                                    ) : null} */}
                                                    {(totalNumberAchieve > numberTarget) ? (
                                                        <FormFeedback type="invalid">
                                                            The archived number target is not match
                                                        </FormFeedback>
                                                    ) : (numberTargetErrorValidation) ?
                                                        <FormFeedback type="invalid">
                                                            The Archived Number Target is required
                                                        </FormFeedback>
                                                        : null}
                                                    <div>
                                                        <Progress
                                                            color="primary"
                                                            value={numberPercentage || 0}
                                                            style={{
                                                                width: "187px",
                                                                height: "12px",
                                                                backgroundColor: "#e7e9ec",
                                                                marginTop: "5px"
                                                            }}
                                                        >
                                                            {`${numberPercentage || 0}%`}
                                                        </Progress>
                                                        <div style={{ display: "flex", justifyContent: "space-between", color: "black", fontSize: "10px" }}>
                                                            <div style={{ color: (totalNumberAchieve) > numberTarget ? "red" : '' }}> {`Achieved: ${(totalNumberAchieve)}`} </div>
                                                            <div>{`Target: ${numberTarget}`}</div>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup className="mb-2">
                                                    <Label htmlFor="validationCustom03">
                                                        Archived Target (Amount)
                                                    </Label>
                                                    <Input
                                                        name="ArchivedAmountTarget"
                                                        placeholder="amount"
                                                        type="text"
                                                        className="form-control-sm"
                                                        onChange={(e) => { handleArchivedAmountTarget(e.target.value) }}
                                                        onBlur={changeStatusValidation.handleBlur}
                                                        // onKeyPress={handleKeyPress}
                                                        value={changeStatusValidation.values.ArchivedAmountTarget}
                                                        invalid={(totalAmountAchieve > amountTarget ||
                                                            (amountTargetErrorValidation)
                                                        )}
                                                    />
                                                    {(totalAmountAchieve > amountTarget) ? (
                                                        <FormFeedback type="invalid">
                                                            The archived amount target is not match
                                                        </FormFeedback>
                                                    ) : (amountTargetErrorValidation) ?
                                                        <FormFeedback type="invalid">
                                                            The Archived Amount Target is required
                                                        </FormFeedback>
                                                        : null}
                                                    <div>
                                                        <Progress
                                                            color="primary"
                                                            value={amountPercentage || 0}
                                                            style={{
                                                                width: "187px",
                                                                height: "12px",
                                                                backgroundColor: "#e7e9ec",
                                                                marginTop: "5px"
                                                            }}
                                                        >
                                                            {`${amountPercentage || 0}%`}
                                                        </Progress>
                                                        <div style={{ display: "flex", justifyContent: "space-between", color: "black", fontSize: "10px" }}>
                                                            <div> {`Achieved: ${totalAmountAchieve}`} </div>
                                                            <div>{`Target: ${amountTarget}`}</div>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            {titleTypeValue == 8 &&
                                                <Col md={2}>
                                                    <FormGroup className="mb-2">
                                                        <Label htmlFor="validationCustom03">
                                                            Dc Figure
                                                        </Label>
                                                        <Input
                                                            name="DcFigure"
                                                            placeholder="DcFigure"
                                                            type="text"
                                                            className="form-control-sm"
                                                            onChange={changeStatusValidation.handleChange}
                                                            onBlur={changeStatusValidation.handleBlur}
                                                            onKeyPress={handleKeyPress}
                                                            value={changeStatusValidation.values.DcFigure}
                                                            invalid={
                                                                changeStatusValidation.touched.DcFigure && changeStatusValidation.errors.DcFigure
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        {changeStatusValidation.touched.DcFigure && changeStatusValidation.errors.DcFigure ? (
                                                            <FormFeedback type="invalid">
                                                                {changeStatusValidation.errors.DcFigure}
                                                            </FormFeedback>
                                                        ) : null}
                                                    </FormGroup>
                                                </Col>
                                            }
                                            <Col md={3} style={{ marginTop: "25px" }}>
                                                {/* <Label htmlFor="validationCustom03" style={{ color: "#a80808" }}>
                                                    Note:  Create Lead with lead type {taskTtile}
                                                </Label> */}
                                                {parseInt(titleTypeValue) == 3 || parseInt(titleTypeValue) == 4 || parseInt(titleTypeValue) == 5 || parseInt(titleTypeValue) == 6 ?
                                                    <Button
                                                        color="primary"
                                                        style={{ width: "100%" }}
                                                        task-title="primary"
                                                        className="btn btn-primary btn-sm "
                                                        // type="submit"
                                                        onClick={() => { handleCreateTaskTitle(taskTtile) }}
                                                    >
                                                        {parseInt(titleTypeValue) == 6 ? "Create Customer Attend" : parseInt(titleTypeValue) == 4 ? "Create Appointment" : parseInt(titleTypeValue) == 3 ? "Create Parcel" : parseInt(titleTypeValue) == 5 ? "Create Making" : ""}
                                                    </Button> : ''
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <FormGroup className="mb-2">
                                                <Label htmlFor="validationCustom03" className="required">
                                                    Remarks
                                                </Label>
                                                <Input
                                                    name="Remarks"
                                                    placeholder="Enter remark here"
                                                    type="textarea"
                                                    className="form-control-sm"
                                                    onChange={changeStatusValidation.handleChange}
                                                    onBlur={changeStatusValidation.handleBlur}
                                                    value={changeStatusValidation.values.Remarks}
                                                    invalid={
                                                        changeStatusValidation.touched.Remarks && changeStatusValidation.errors.Remarks
                                                            ? true
                                                            : false
                                                    }
                                                />
                                                {changeStatusValidation.touched.Remarks && changeStatusValidation.errors.Remarks ? (
                                                    <FormFeedback type="invalid">
                                                        {changeStatusValidation.errors.Remarks}
                                                    </FormFeedback>
                                                ) : null}
                                            </FormGroup>
                                        </Row>

                                        <div className="text-end">
                                            <Button
                                                task-title="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                type="reset"
                                                color="secondary"
                                                onClick={() => { changeStatustoggle() }}
                                            >
                                                Cancel
                                            </Button>
                                            {formSumitLoading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    task-title="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal>
                    </CardBody>
                </Card>

                {taskTtile == "Shop visit" && createTaskTtileModal &&
                    <LeadCreateModal
                        modal={createTaskTtileModal}
                        toggle={taskTitleToggle}
                        isEdit={false}
                        LeadListApi={''}
                        editData={''}
                        leadId={0}
                    />
                }
                {parseInt(titleTypeValue) == 4 && createTaskTtileModal &&
                    <CreateAppointmentModel
                        modal={createTaskTtileModal}
                        toggle={taskTitleToggle}
                        isEdit={false}
                        editData={''}
                        AppointmentListApi={''}
                        AssignByData={statusData}
                    />
                }
                {parseInt(titleTypeValue) == 3 && createTaskTtileModal &&
                    <CreateParcelModel
                        modal={createTaskTtileModal}
                        toggle={taskTitleToggle}
                        ParcelListApi={''}
                    />
                }

                {parseInt(titleTypeValue) == 5 && createTaskTtileModal &&
                    <CreateMakingModel
                        modal={createTaskTtileModal}
                        toggle={taskTitleToggle}
                        MakingListApi={''}
                        isEdit={false}
                        editData={''}
                    />
                }

                {parseInt(titleTypeValue) == 6 && createTaskTtileModal &&
                    <CreateCustomerAttendModel
                        modal={createTaskTtileModal}
                        toggle={taskTitleToggle}
                        customerAttendListApi={''}
                        isEdit={false}
                        editData={''}
                    />
                }

                <Modal
                    isOpen={viewArchivedModal}
                    toggle={ArchivedModel}
                    centered={true}
                    size="small"
                >
                    <div className="modal-content">
                        <ModalHeader className="text-centre" toggle={ArchivedModel} tag="h5">
                            Task History
                        </ModalHeader>
                        <ModalBody>
                            <TaskArchiveDetails id={taskId} />
                        </ModalBody>
                    </div>
                </Modal>

                <Modal
                    isOpen={modalStatusChange}
                    toggle={toggleStatusChange}
                    centered={true}
                    style={{ width: isMobile ? "" : "300px" }}
                    size="default"
                >
                    <div className="modal-content">
                        <ModalHeader className="text-centre" toggle={toggleStatusChange} tag="h5">
                            Change Status
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <FormGroup>
                                    <Input
                                        type="select"
                                        id="validationCustom01"
                                        className="form-control"
                                        name="taskType"
                                        // onChange={validation.handleChange}
                                        onChange={e => {
                                            setStatusChange(e.target.value)
                                        }}
                                        value={statusChange}
                                        bsSize="sm"
                                    >
                                        {GetObjByTaskStatus(0, 1, 2, 3, 4).map((item, index) => {
                                            return (
                                                <option key={index} value={item.Value}>
                                                    {item.Key}
                                                </option>
                                            )
                                        })}
                                    </Input>
                                </FormGroup>
                            </Row>

                            <Row>
                                <div className="text-end ">
                                    <Button
                                        task-title="secondary"
                                        className="btn btn-primary me-2 btn-sm "
                                        type="reset"
                                        color="secondary"
                                        onClick={() => { toggleStatusChange(), setStatusChange(0) }}
                                    >
                                        Cancel
                                    </Button>
                                    {formSumitLoading ? (
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                        >
                                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                            Loading
                                        </button>
                                    ) : (
                                        <Button
                                            color="primary"
                                            task-title="primary"
                                            className="btn btn-primary btn-sm "
                                            type="button"
                                            onClick={() => hadleStatusChangeSave()}
                                        >
                                            Submit
                                        </Button>
                                    )}
                                </div>
                            </Row>
                        </ModalBody>
                    </div>
                </Modal>

            </div >
        </div >
    )
}
TaskList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default TaskList
